export default function InputFile({ onChange, title }) {
  return (
    <span className="p-button input-file mr-3">
      <i className="pi pi-file-excel mr-2"></i> {title}
      <input name="file" type="file" onChange={onChange} />
    </span>
  );
}
